// components
import { Unstable_TrapFocus as FocusTrap } from '@mui/material';

// types
import type { FormPanelProps } from './FormPanel.types';

// styles
import { Container } from '../../AppointmentFormContainer.styles';

/**
 * The side panel that holds the appointment form. Tab and Shift+Tab stay inside it: past the
 * last control focus wraps to the first, and back. The panel is not a modal, so only the
 * keyboard loops — a click on the calendar next to it still moves focus there.
 */
const FormPanel = ({ children }: FormPanelProps) => {
  'use memo';
  return (
    <FocusTrap
      open
      // The form focuses its own first field once an appointment opens
      disableAutoFocus
      // Loop the keyboard only; never pull focus back from the calendar or the page
      disableEnforceFocus
      // Leave focus after closing to the existing close flow
      disableRestoreFocus
    >
      {/* Focusable itself, as FocusTrap requires of its root; not in the Tab order */}
      <Container tabIndex={-1}>{children}</Container>
    </FocusTrap>
  );
};

export default FormPanel;
